import { render } from "./AdminAccessDenied.vue?vue&type=template&id=4d210d98&scoped=true"
import script from "./AdminAccessDenied.vue?vue&type=script&lang=js"
export * from "./AdminAccessDenied.vue?vue&type=script&lang=js"

import "./AdminAccessDenied.vue?vue&type=style&index=0&id=4d210d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d210d98"]])

export default __exports__